import styled from 'styled-components';

import THEME from 'constants/theme';

export const FilterPopover = styled.div.attrs({
  className: 'FilterPopover',
})<{ $isOpen: boolean }>(
  ({ $isOpen }) => `
    display: ${$isOpen ? 'flex' : 'none'};
    position: absolute;
    top: 60px;
    left: 10px;
    z-index: 1000;
    background: #192225;
    border-radius: 5px;
    padding: 15px;
    flex-direction: column;
    gap: 10px;
    min-width: 300px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.5);
  `
);

export const FilterContainer = styled.div.attrs({
  className: 'FilterContainer',
})`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const FilterSection = styled.div.attrs({
  className: 'FilterSection',
})`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const FilterTitle = styled.div.attrs({
  className: 'FilterTitle',
})`
  color: #ffffff;
  font-size: 14px;
  font-weight: 500;
  border-bottom: 1px solid #444;
  padding-bottom: 5px;
`;

export const FilterLabel = styled.label.attrs({
  className: 'FilterLabel',
})`
  color: #ffffff;
  font-size: 13px;
  font-weight: 500;
  margin-bottom: 5px;
  display: block;
`;

export const MultiSelectContainer = styled.div.attrs({
  className: 'MultiSelectContainer',
})`
  position: relative;
  width: 100%;
`;

export const MultiSelectButton = styled.button.attrs({
  className: 'MultiSelectButton',
})`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  background: #2a3538;
  color: #fff;
  border: 1px solid #444;
  border-radius: 5px;
  padding: 8px 10px;
  font-size: 13px;
  cursor: pointer;
  outline: none;
  text-align: left;

  > span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  > svg {
    flex-shrink: 0;
  }

  &:hover {
    border-color: #666;
  }

  &:focus {
    border-color: ${THEME.identifier};
  }

  &:disabled {
    cursor: default;
    opacity: 0.6;
  }
`;

export const MultiSelectPanel = styled.div.attrs({
  className: 'MultiSelectPanel',
})`
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  z-index: 1001;
  background: #2a3538;
  border: 1px solid #444;
  border-radius: 5px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.5);
`;

export const MultiSelectActions = styled.div.attrs({
  className: 'MultiSelectActions',
})`
  display: flex;
  justify-content: space-between;
  padding: 6px 10px;
  border-bottom: 1px solid #444;

  > button {
    background: none;
    border: none;
    color: #8ab4f8;
    font-size: 12px;
    cursor: pointer;
    padding: 0;
  }
`;

export const MultiSelectList = styled.div.attrs({
  className: 'MultiSelectList',
})`
  max-height: 320px;
  overflow-y: auto;
  padding: 4px 0;
`;

export const MultiSelectGroups = styled.div.attrs({
  className: 'MultiSelectGroups',
})`
  padding-bottom: 4px;
  margin-bottom: 4px;
  border-bottom: 1px solid #444;

  > label > span {
    font-weight: 600;
  }
`;

export const MultiSelectOption = styled.label.attrs({
  className: 'MultiSelectOption',
})`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 5px 10px;
  color: #fff;
  font-size: 13px;
  cursor: pointer;

  &:hover {
    background: #34444a;
  }

  > input {
    margin: 0;
    cursor: pointer;
    accent-color: ${THEME.identifier};
  }
`;

export const FilterButtons = styled.div.attrs({
  className: 'FilterButtons',
})`
  display: flex;
  gap: 8px;
  margin-top: 5px;
  padding-top: 10px;
  border-top: 1px solid #444;
`;

export const FilterButton = styled.button.attrs({
  className: 'FilterButton',
})<{ $variant: 'primary' | 'secondary' }>(
  ({ $variant }) => `
    flex: 1;
    background: ${$variant === 'primary' ? THEME.identifier : '#444'};
    color: #fff;
    border: none;
    border-radius: 5px;
    height: 32px;
    cursor: pointer;
    font-size: 13px;
    font-weight: 500;
    transition: background 0.2s;

    &:hover {
      background: ${$variant === 'primary' ? '#6b1f00' : '#555'};
    }

    &:active {
      transform: scale(0.98);
    }
  `
);

export const FilterIconButton = styled.div.attrs({
  className: 'FilterIconButton',
})<{ $isActive: boolean }>(
  ({ $isActive }) => `
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border-radius: 5px;
    cursor: pointer;
    background: ${$isActive ? THEME.identifier : '#222'};
    color: #ccc;
    transition: background 0.2s;

    &:hover {
      background: ${$isActive ? '#6b1f00' : '#444'};
    }

    > svg {
      width: 18px;
      height: 18px;
    }
  `
);

export const FilterInfoMessage = styled.div.attrs({
  className: 'FilterInfoMessage',
})`
  color: #999;
  font-size: 13px;
  text-align: center;
  padding: 20px;
  line-height: 1.5;
  border-radius: 5px;
  background: #1a2326;
  border: 1px dashed #444;
`;
